<template>
  <div style="padding-bottom: 150px; padding-top: 150px;">

    <b-form @submit="onSubmit" class="b-white p-5 rounded b-shadow">
      <p class="text-center h4 mb-3" style="color: #ed8f00 !important;">
        ¡Completa la información para continuar con la experiencia kllaar.com!
      </p>
      <h4 class="font-blue">Usuario</h4>
      <hr>

      <b-form-group class="is-invalid" v-if="exist_email==0">
        <label>Correo electrónico <b class="font-orange">*</b></label>
        <b-form-input v-model="form.email" type="email" required placeholder="Ingresa tu cuenta de correo">
        </b-form-input>
        <b-form-invalid-feedback :state="false" v-if="this.response.email">
          {{response.email[0]}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="LinkedIn">
        <b-form-input type="text" v-model="form.url_linkedIn" placeholder="https://www.linkedin.com/"></b-form-input>
      </b-form-group>
      <b-form-group label="Facebook">
        <b-form-input type="text" v-model="form.url_facebook" placeholder="https://www.facebook.com/"></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-3" label-for="input-3">
        <label>¿Cómo te enteraste de Kllaar.com? <b class="font-orange">*</b></label>
        <b-form-select
            id="input-3"
            v-model="form.how"
            :options="como"
            required
        ></b-form-select>
      </b-form-group>

      <b-form-group label="" v-if="form.how == 'Otro'">
        <b-form-input type="text" required placeholder="¿Cómo te enteraste?"></b-form-input>
      </b-form-group>

      <b-form-group>
        <b-form-checkbox-group v-model="form.notificaciones" id="checkboxes-4">
          <b-form-checkbox value="acepto">Deseo recibir comunicados, publicidad desarrollados por Kllaar.
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>

      <b-button type="submit" class="b-orange col-sm-12" :disabled="loading">
        Continuar
        <b-spinner v-if="loading" small label="Espere ..."></b-spinner>
      </b-button>

    </b-form>

  </div>
</template>
<script>
export default {
  name: "formStudent",
  props:['exist_email'],
  data() {
    return {
      loading: false,
      como: [{text: 'Selecciona una opción', value: null}, 'Un amigo', 'Internet', 'Redes Sociales', 'Otro'],
      form: {
        email:'',
        sitio_web: '',
        url_facebook: '',
        url_linkedIn: '',
        how: null,
        notificaciones: []
      },
      response : []
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      this.loading = true
      this.$bus.$emit('registerStudent', this.form)
    }
  },
  created() {

    this.$bus.$on('registerStudentResponse', (data)=>{
      this.loading = false
      this.response = data
    })



  }
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/validate/pages/formStudent.vue